import React, { useRef, useEffect } from 'react';
import "./feedback_modal.css";
import { useNavigate } from 'react-router-dom';
import fb_message from "../Assets/modal_graphics/feedback_modal_message.png";
import ThankYou_audio from "../Assets/ThankYou_Page/modal_audio.mp3";

const FeedbackModal = ({ show, showHomeButton }) => {
    const navigate = useNavigate();
    const audioRef = useRef(new Audio(ThankYou_audio))

    useEffect(() => {
        const audio = audioRef.current;
        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (!show) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }, [show]);

    const play = () => {
        if (audioRef.current.paused) {
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    }

    const handleReturn = () => {
        // Exit pseudo fullscreen
        const htmlElement = document.documentElement;
        const bodyElement = document.body;
        if (htmlElement.classList.contains('pseudo-fullscreen')) {
            htmlElement.classList.remove('pseudo-fullscreen');
            bodyElement.classList.remove('pseudo-fullscreen');
            localStorage.setItem('pseudoFullscreen', 'false');
            
            const event = new CustomEvent('pseudoFullscreenChange', { 
                detail: { isFullScreen: false } 
            });
            window.dispatchEvent(event);
        }

        if (showHomeButton) {
            localStorage.setItem('returnedFromTest', 'true');
            navigate('/');
        } else {
            // Return to home 
            localStorage.removeItem('testUID');
            localStorage.removeItem('JWT');
            localStorage.removeItem('testLevel');
            navigate('/?skipWelcome=true');
        }
    }

    if (!show) return null; 

    return (
        <div className='button_modal'>
            <div className='button_modal_content'>
                <img src={fb_message} alt="Feedback message" className='fb_message' onClick={play} />
                <button className={showHomeButton?'return_to_home':'close_window'} onClick={handleReturn}>
                </button>
            </div>
        </div>
    );
}

export default FeedbackModal;
